export { ComingSoonPage } from './src/coming-soon-page';
